import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Helmet } from 'react-helmet';

const Settings = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('profile');

  return (
    <>
      <Helmet>
        <title>Account Settings | SERPfinity\u2122</title>
        <meta name="description" content="Manage your SERPfinity account settings, profile, and preferences." />
      </Helmet>
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Account Settings</h1>
        <p className="text-gray-600 mb-6">Manage your account preferences and profile information.</p>

        <div className="border-b border-gray-200 mb-6">
          <nav className="flex space-x-8">
            {['profile', 'notifications', 'billing'].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`pb-3 px-1 text-sm font-medium border-b-2 transition-colors ${
                  activeTab === tab
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700'
                }`}
              >
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </button>
            ))}
          </nav>
        </div>

        {activeTab === 'profile' && (
          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">Profile Information</h2>
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">First Name</label>
                  <input type="text" defaultValue={user?.firstName || ''} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm" readOnly />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
                  <input type="text" defaultValue={user?.lastName || ''} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm" readOnly />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input type="email" defaultValue={user?.email || ''} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm" readOnly />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Company</label>
                <input type="text" defaultValue={user?.company || ''} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm" readOnly />
              </div>
              <p className="text-xs text-gray-400">Contact support to update your profile information.</p>
            </div>
          </div>
        )}

        {activeTab === 'notifications' && (
          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">Notification Preferences</h2>
            <div className="space-y-4">
              {['Ranking changes', 'AI visibility updates', 'Weekly summary reports', 'New feature announcements'].map((item) => (
                <label key={item} className="flex items-center justify-between py-2">
                  <span className="text-sm text-gray-700">{item}</span>
                  <input type="checkbox" defaultChecked className="h-4 w-4 text-blue-600 rounded border-gray-300" />
                </label>
              ))}
            </div>
            <p className="text-xs text-gray-400 mt-4">Notification settings coming soon.</p>
          </div>
        )}

        {activeTab === 'billing' && (
          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">Plan & Billing</h2>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-blue-900">Current Plan: <span className="font-bold">{user?.plan || 'Free'}</span></p>
                  <p className="text-xs text-blue-700 mt-1">Free trial: 7 days remaining</p>
                </div>
                <a href="/pricing" className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700">Upgrade Plan</a>
              </div>
            </div>
            <p className="text-xs text-gray-400">Billing management coming soon. Contact support for plan changes.</p>
          </div>
        )}
      </div>
    </>
  );
};

export default Settings;